// images
import newsCoverImg1 from '../images/blog-details/image-1.jpg';
import newsCoverImg2 from '../images/blog-details/image-2.jpg';
import newsCoverImg3 from '../images/blog-details/image-3.jpg';
import newsCoverImg4 from '../images/blog-details/image-4.jpg';

const blogs = [
	{
		id: '4',
		title: "Nouveau dispositif d'accompagnement des victimes de violences intrafamiliales",
		slug: 'nouveau_dispositif_d_accompagnement_des_victimes_de_violences_intrafamiliales',
		description:
			'Les violences intrafamiliales ne laissent pas toujours des traces visibles. Elles peuvent être physiques, psychologiques, économiques, sexuelles ou encore administratives. Dans tous les cas, leurs conséquences sont profondes et les victimes se sentent souvent isolées, démunies ou hésitent à entreprendre des démarches.',
		newsCoverImg: newsCoverImg4,
		comp: 'News4',
	},
	{
		id: '3',
		title: 'Nouveau Livre 6 : Responsabilité des mineurs et des parents',
		slug: 'nouveau_livre_6_responsabilite_des_mineurs_et_des_parents',
		description:
			'Depuis le 1er janvier 2025, le Nouveau Livre 6 du Code civil est entré en vigueur. La volonté du législateur était notamment de moderniser le droit de la responsabilité extracontractuelle tout en tenant compte des évolutions jurisprudentielles en la matière.',
		newsCoverImg: newsCoverImg3,
		comp: 'News3',
	},
	{
		id: '2',
		title: 'Télétravail & assurances : les bons réflexes à avoir...',
		slug: 'teletravail_et_assurances__les_bons_reflexes_a_avoir',
		description:
			"La période de confinement liée au Coronavirus COVID-19 nous a poussés à changer nos habitudes (diminution de nos déplacements, télétravail, etc...). Cette modification de nos habitudes peut entraîner certaines questions en matière d'assurances ...",
		newsCoverImg: newsCoverImg2,
		comp: 'News2',
	},
	{
		id: '1',
		title: "Victime d'un sinistre ? Les premiers réflexes à avoir !",
		slug: 'victime_d_un_sinistre__les_premiers_reflexes_a_avoir',
		description:
			"Vous êtes victime d'un sinistre (accident de la circulation, dégâts des eaux, etc...) et vous disposez d'une assurance ?",
		newsCoverImg: newsCoverImg1,
		comp: 'News1',
	},
];
export default blogs;
